<div class="layout">
  @if (!sidebarService.isMobile()) {
    <app-menu-sidebar/>
  } @else {
    <p-drawer [(visible)]="sidebarService.isDrawerVisible" position="left" [modal]="true" [dismissible]="true" [closeOnEscape]="true" [closable]="false" [blockScroll]="true"
             [pt]="{ header: { style: 'display: none' }, content: { style: 'padding: 0; overflow: hidden' }, root: { style: 'background: #F0F2F5' } }">
      <app-menu-sidebar/>
    </p-drawer>
  }
  <div class="main">
    @if (!hideHeader()) {
      <app-admin-header></app-admin-header>
    }
    <p-scrollpanel [style]="{ width: '100%', height: hideHeader() ? '100%' : '88%' }">
      <router-outlet />
    </p-scrollpanel>
  </div>
</div>
